import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=stunning%20aerial%20view%20of%20Mount%20Fuji%20with%20cherry%20blossom%20trees%20in%20full%20bloom%20in%20foreground%2C%20pink%20sakura%20petals%20floating%20in%20gentle%20breeze%2C%20spring%20morning%20with%20soft%20golden%20sunlight%2C%20dreamy%20atmospheric%20landscape%20photography%2C%20layered%20composition%20with%20depth%2C%20warm%20pastel%20color%20palette%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=sakura-hero-bg-01&orientation=landscape"
        alt="樱花视频 - 高清樱花视频在线观看平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-wide">
          足不出户 <span className="text-primary-300">赏最美樱花</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          樱花视频汇聚全球各地樱花盛开实录、延时摄影、旅行Vlog及赏樱攻略视频<br className="hidden sm:block" />
          收藏你最爱的樱花视频，感受春日限定的浪漫
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/japan-sakura"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始赏樱
          </Link>
          <Link
            to="/category/viewing-guide"
            className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-guide-line mr-2"></i>
            赏樱攻略
          </Link>
        </div>
        <div className="mt-10 flex items-center justify-center gap-8 text-white/60 text-sm">
          <div className="text-center">
            <div className="text-2xl font-bold text-white">1000+</div>
            <div className="text-xs mt-0.5">高清视频</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-white">50万+</div>
            <div className="text-xs mt-0.5">樱花爱好者</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-white">5大</div>
            <div className="text-xs mt-0.5">内容分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}